





















































































import Draggable from 'vuedraggable';
import { mapActions, mapState } from 'vuex';
import { component as AssetManagerComposer } from '@/composers/asset-manager';
import asset, { IFile, IValidation } from '@/services/asset';
import FullscreenButton from '@/components/FullscreenButton.vue';
import LoaderInline from '@/components/LoaderInline.vue';
import AssetManagerRegion from './AssetManagerRegion.vue';

export default AssetManagerComposer({
  methods: {
    uploadAsk() {
      this.$refs.uploadInput.click();
    },
  },
  components: {
    AssetManagerRegion,
    Draggable,
    FullscreenButton,
    LoaderInline,
  },
} as IView);
